import { render, staticRenderFns } from "./templateColumnDesigner.vue?vue&type=template&id=4b19c8c8&scoped=true"
import script from "./templateColumnDesigner.vue?vue&type=script&lang=js"
export * from "./templateColumnDesigner.vue?vue&type=script&lang=js"
import style0 from "./templateColumnDesigner.vue?vue&type=style&index=0&id=4b19c8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b19c8c8",
  null
  
)

export default component.exports